import React, {useState, useEffect,useContext} from 'react';
import { GenerateLogList } from '../models/StudyEvaluation';

const GeneratedLogPage : React.FC<any> = (props) => {

    const data = props.location.state.data;
    const [listLog, setListLog] = useState<GenerateLogList[]>([]) 

    const renderList = () => {
    
        return listLog.map((item, index) => {
          return (
            <React.Fragment>
                <tr key={item.GENERATED_DATE}>
                    <td>{index + 1}</td>
                    <td>{item.INSTITUTION}</td>
                    <td>{item.PROGRAM}</td>
                    <td>{item.SEMESTER}</td>
                    <td>{item.GENERATED_BY}</td>
                    <td>{item.GENERATED_DATE}</td>
                </tr>
            </React.Fragment>
            );
        })
    }

    useEffect(() => {
        setListLog(data)
    },[])

    return (
        <React.Fragment>
           <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Generated Log</h1>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">List</h3>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive p-0">
                                        <table className="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Institution</th>
                                                    <th>Program</th>
                                                    <th>Semester</th>
                                                    <th>Generated By</th>
                                                    <th>Generated Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {renderList()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default GeneratedLogPage;